/**
 * The lead intro component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18438-27719&m=dev
 */
const LeadIntro = (): React.ReactElement => {
  return (
    <div data-testid="lead-intro-component" className="mb-6">
      <span className="inline-block bg-gray-250 px-2 py-1 font-poppins text-xs font-light leading-4 tracking-2% text-gray-850">
        WEEKLY NEWSLETTER
      </span>

      <h1 className="my-2 font-lct text-10xl font-bold leading-tight text-gray-850 xs:text-12xl">
        Decoding Asia
      </h1>

      <p className="mb-2 font-poppins text-base font-normal leading-normal text-gray-850">
        {
          "Receive weekly insights on South-east Asia's fastest-growing economies."
        }
      </p>

      <p className="mb-6 font-poppins text-base font-normal leading-normal text-gray-850">
        {
          "From critical economic shifts to data-driven business analysis, this is your map for navigating the new global order."
        }
      </p>
    </div>
  );
};

export default LeadIntro;
